import React, { Component } from "react";
import { connect } from "react-redux";
import { actions as libraryActions } from "../../../../redux/ui/library";
import styled from "styled-components";
import ninja from "@vitalsource/vstui/colors/ninja";
import { MobileLogo } from "./logo";
import HamburgerMenu from "../icons/HamburgerMenu";
import { Button } from "@vitalsource/vstui";
import createThemedComponent from "@vitalsource/vstui/themes/createThemedComponent";
import { t } from "../../../core/translate";
import SearchIcon from "../icons/Search";

const ThemedButton = createThemedComponent(Button, {
  Button_borderWidth: 0,
  Button_paddingHorizontal_medium: 0
});

const StyledHeader = styled.header`
  flex-grow: 0;
  align-items: center;
  height: 44px;
  min-height: 44px;
  left: ${props => props.offset}px;
  background: ${ninja.getShade(11)};
  position: fixed;
  top: 0;
  z-index: 2;

  display: flex;
  justify-content: space-between;
  padding: 0 24px;
`;

class MobileHeader extends Component {
  constructor() {
    super();
    this.state = {};
  }

  render() {
    const {
      isSmall,
      offset,
      toggleMobileHeaderMenu,
      openMobileLibSearchPanel,
      librarySearch
    } = this.props;

    return (
      <StyledHeader isSmall={isSmall} offset={offset}>
        <ThemedButton
          label={t("my-label", "Menu")}
          naked
          onClick={toggleMobileHeaderMenu}
        >
          <HamburgerMenu />
        </ThemedButton>
        <MobileLogo />
        {librarySearch && (
          <Button
            onClick={() => openMobileLibSearchPanel()}
            label={t("base.search")}
            naked
            inline
            iconStart={<SearchIcon />}
          />
        )}
      </StyledHeader>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  toggleMobileHeaderMenu: () =>
    dispatch(libraryActions.toggleMobileHeaderMenu()),
  openMobileLibSearchPanel: data =>
    dispatch(libraryActions.openMobileLibSearchPanel())
});

export default connect(
  null,
  mapDispatchToProps
)(MobileHeader);
